<template>
  <base-dialog width="560px" show-close :visible.sync="visible" class="save-condition-dialog">
    <template v-slot:header>编辑条件</template>
    <el-form ref="form" :model="condition" label-width="110px" :rules="rules" label-position="left">
      <el-form-item :label="`${type}名称`" prop="name">
        <el-input v-model="condition.name"></el-input>
      </el-form-item>
      <el-form-item :label="`${type}范围`" prop="filters">
        <div class="content-item">
          <condition-list
            class="condition-list"
            :conditions="condition.filters"
            :search-sheet="sheet"
            :rely-sheet="sheet"
          ></condition-list>
        </div>
      </el-form-item>
    </el-form>
    <template v-slot:footer>
      <span class="dialog-footer">
        <base-button @click="visible = false">取消</base-button>
        <base-button type="primary" @click="submit">确认</base-button>
      </span>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"
import ConditionList from "@/components/UIComponents/ConditionList/ConditionList"
import { getAllDefaultControls, getAvailableSheets } from "@/api/sheet/sheet"
import { transFieldControl } from "@/utils/sheet"

export default {
  name: "save-condition-dialog",
  components: { BaseDialog, BaseButton, ConditionList },
  inject: ["app"],
  props: {
    sheet: Object,
    type: {
      type: String,
      default: "规则"
    }
  },
  data() {
    return {
      visible: false,
      condition: {},
      rules: {
        name: [{ required: true, message: `请填写${this.type}名称`, trigger: "blur" }],
        filters: [{ required: true, message: "请设置规则" }]
      },
      allDefaultControls: []
    }
  },
  computed: {
    curSheet() {
      return this.sheetMap[this.condition.sheetId] || {}
    },
    syncTargets() {
      return (this.curSheet.controls || [])
        .filter(c => c._type === "company")
        .map(c => ({ label: `${this.curSheet.name}.${c.name}`, value: c._cid }))
    },
    curUser() {
      return this.$store.getters.userInfo
    },
    relySheetFields() {
      if (!this.sheet.id || Object.keys(this.controlsMap).length == 0) return []
      return this.sheet.controls.map(ctrl => {
        ctrl = transFieldControl(ctrl)
        return {
          label: `[${this.controlsMap[ctrl._type].name}] ${ctrl.name}`,
          value: ctrl._cid,
          _dataType: ctrl._dataType
        }
      })
    },
    controlsMap() {
      return this._.keyBy(this.allDefaultControls, "_type")
    }
  },
  created() {
    getAllDefaultControls().then(res => (this.allDefaultControls = res))
    getAvailableSheets({ appId: this.app.id }).then(groupedSheets => {
      this.sheets = groupedSheets.find(app => app.id === this.app.id)?.sheets || []
      this.sheetMap = this._.chain(groupedSheets)
        .map(s => s.sheets)
        .flatten()
        .keyBy("sheetId")
        .value()
    })
  },
  methods: {
    open(condition) {
      condition = condition ? this._.cloneDeep(condition) : {}
      condition.filters = condition.filters || []
      this.condition = condition
      this.visible = true
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.$emit("submit", this.condition)
        this.visible = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.save-condition-dialog {
  .el-select {
    width: 100%;
  }
  ::v-deep .el-dialog {
    .el-dialog__body {
      padding: 20px;
      color: unset;
    }
  }
}
</style>
